module.exports = __webpack_public_path__ + "static/media/Debris.7fbf5e48.svg";